









import { Component, Vue, Prop } from "vue-property-decorator";
import LoginProcessCard from "../components/LoginProcessCard.vue";

@Component({
  components: { LoginProcessCard },
})
export default class LoginRequest extends Vue {
  @Prop({ required: true })
  token!: string;
  @Prop({ required: false, default: "" })
  suffix!: string;
}
